// removed by extract-text-webpack-plugin
module.exports = {"root":"Pointer__root___3AUvH"};